import React from 'react';
import GroupSessionsView from 'components/session/GroupSessionsView';

// Entrenador: solo SUS sesiones grupales (scope por trainer_id). Layout two-pane.
function TrainerGroupSessionsPage() {
  return <GroupSessionsView trainerScoped />;
}

export default TrainerGroupSessionsPage;
